import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationResidenceTodoApiService } from './organization-residence-todo-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationResidenceTodoApiService extends GeneratedOrganizationResidenceTodoApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
